module.exports = __webpack_public_path__ + "media/images/flags/1x1/cze-f3f43719254d2981519e05822df33961.svg";